import { render } from "./ChatbotWrapper.vue.ts?vue&type=template&id=408dbb2e&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatbotWrapper.vue?vue&type=template&id=408dbb2e&scoped=true&ts=true"
import script from "./ChatbotWrapper.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatbotWrapper.vue?vue&type=script&lang=ts"
export * from "./ChatbotWrapper.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatbotWrapper.vue?vue&type=script&lang=ts"

import "./ChatbotWrapper.vue.scss?vue&type=style&index=0&id=408dbb2e&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatbotWrapper.vue?vue&type=style&index=0&id=408dbb2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408dbb2e"],['__file',"src/apps/core-app-onboarding/components/ChatbotWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "408dbb2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('408dbb2e', __exports__)) {
    api.reload('408dbb2e', __exports__)
  }
  
  module.hot.accept("./ChatbotWrapper.vue.ts?vue&type=template&id=408dbb2e&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatbotWrapper.vue?vue&type=template&id=408dbb2e&scoped=true&ts=true", () => {
    api.rerender('408dbb2e', render)
  })

}


export default __exports__